/**
 * mobil tlp trip & point superior access setup
 */

export const superiorSalesList = {
  'PVL-JH01': ['PVL-MK01'],
}

export const superiorArray = ['PVL-JH01']
